export default {
  path: '/tiktok',
  component: () => import('@/views/tiktok/index.vue'),
  children: [
    {
      path: 'products',
      name: 'TiktokProductsList',
      component: () => import('@/views/tiktok/pages/ProductsList.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'management',
          'marketing',
          'inventory_and_costing',
          'online_admin',
          'support'
        ]
      }
    },
    {
      path: 'products/create',
      name: 'TiktokCreateProduct',
      component: () => import('@/views/tiktok/pages/ProductForm.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'management',
          'marketing',
          'inventory_and_costing',
          'online_admin',
          'support'
        ]
      }
    },
    {
      path: 'products/:productId',
      name: 'TiktokEditProduct',
      component: () => import('@/views/tiktok/pages/ProductForm.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'management',
          'marketing',
          'inventory_and_costing',
          'online_admin',
          'support'
        ]
      }
    },
    {
      path: 'request-log',
      name: 'TiktokRequestLog',
      component: () => import('@/views/tiktok/pages/RequestLog.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'support'
        ]
      }
    },
    {
      path: 'webhook-log',
      name: 'TiktokWebhookLog',
      component: () => import('@/views/tiktok/pages/WebhookLog.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'support'
        ]
      }
    },
    {
      path: 'token-log',
      name: 'TiktokTokenLog',
      component: () => import('@/views/tiktok/pages/TokenLog.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'support'
        ]
      }
    },
    {
      path: 'select-store',
      name: 'TiktokSelectStore',
      component: () => import('@/views/tiktok/pages/SelectStore.vue'),
      meta: {
        layout: 'Blank'
      }
    },
    {
      path: 'authorized-shop',
      name: 'TiktokAuthorizedShop',
      component: () => import('@/views/tiktok/pages/AuthorizedShop.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'support'
        ]
      }
    },
    {
      path: 'order',
      name: 'TiktokOrderList',
      component: () => import('@/views/tiktok/pages/OrderList.vue'),
      meta: {
        middleware: [
          'auth',
          'online_admin',
          'warehouse_manager',
          'developer',
          'support'
        ]
      }
    },
    {
      path: 'return-order',
      name: 'TiktokReturnOrder',
      component: () => import('@/views/tiktok/pages/ReturnOrder.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'support'
        ]
      }
    },
    {
      path: 'sync-order-error',
      name: 'TiktokSyncOrderError',
      component: () => import('@/views/tiktok/pages/SyncOrderError.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'support'
        ]
      }
    }
  ]
}
